<template>

  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Informción de Suscripción Inicial
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
          Ante cualquier duda, comuníquese con su promotor.
          </p>
        </md-card-content> 
      </md-card>   

      <md-card class="md-elevation-0 m-5" :class="getValidationClass2('fondos')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Seleccione el(los) fondo(s) mutuo(s) en el(los) que desea invertir e indique los montos.*
          <p align="justify">
            Los aportes deben ser realizados en dólares y solo mediante transferencias bancarias.  
          </p>
                  
        </md-card-header>
        <md-card-content class="md-layout">
          
          <div class="justify">
              <div class="md-layout-item md-layout" v-for="(value, i) in form.fondomutuoinvertir" :key="i" :set="v = $v.form.fondomutuoinvertir.$each[i]">
              
                <div class="md-layout-item md-layout md-xlarge-size-100 md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100">
                  <div v-if="value.ind == 1" :class="'show'+value.id+value.ind+' show'">
                    <b>Fondos institucionales:</b><br>
                  </div>
                  <div v-if="value.ind == 0" :class="'show'+value.id+value.ind+' show'">
                    <b>Fondos individuales:</b><br>
                  </div>    
                </div>
 

                <div v-show="showItem(value.ind)" class="md-layout-item md-xlarge-size-70 md-large-size-70 md-medium-size-70 md-small-size-75 md-xsmall-size-70">            

                  <md-checkbox v-model="value.check"  :true-value="true" :false-value="false"
                    @change="checkFondos(i, value)">{{value.name}}
                  </md-checkbox>
                </div>

                <div v-show="showItem(value.ind)" class="md-layout-item md-xlarge-size-30 md-large-size-30 md-medium-size-30 md-small-size-25 md-xsmall-size-30 md-alignment-center-right">

                  <div>
                    
                    <ejs-numerictextbox :enabled="value.check"  v-model="value.monto" :value="value.monto"  :decimals="4" :showSpinButton="false" format="n4" />

                    <div class="md-layout-item" :class="getValidationClass(i, 'monto')">
                      <span class="md-error" v-if="!v.monto.required">Esta respuesta es obligatoria.</span>
                      <span class="md-error" v-else-if="!v.monto.decimal">Formato inválido</span>
                      <span class="md-error" v-else-if="!v.monto.minValue">El monto debe ser desde 100 USD.</span>
                    </div>
                  </div>                      

                </div>
              </div>

            <div class="radioform" :class="getValidationClass2('fondos')">
              <span class="md-error" v-if="!$v.form.fondos.required">Esta respuesta es obligatoria.</span>
            </div>              
          
        </div>          

        </md-card-content> 
      </md-card>       

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                
      
    </div>
  </form>
</template>

<style>

.show{
  display: none;
}


</style>

<script>
import { validationMixin } from 'vuelidate'
import {
  minValue,
  requiredIf,
  required,
  decimal,
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Form5',
  data: () => ({
    form:{
    },
    in:null,
    uno:0,
    cero:0
  }),
  mounted: function(){
    this.form = this.$store.state.form.form5
    this.in = this.$store.state.form.form4.inversionistaInstitucional;
    var that = this
    this.form.fondomutuoinvertir.forEach(function(value, i) {

      that.checkItemondos(i, value);

    });
    this.cssTypeFondo()
  },  
  validations: {
    form: {
      fondomutuoinvertir: {
        $each:{
            monto: {
              required: requiredIf(function(form,){
                return form.check   
              }),
              decimal,
              minValue: minValue(100),
            },
        },
      },
      fondos:{required}
    }
  },
  methods: {
    checkItemondos(i, value){
      if(this.in != "Si"){
        if(i >= 3){      
          //console.log('aa->'+value.name)
          if(value.check){
            if(this.form.fondos.indexOf(i) == -1){
              this.form.fondos.push(i)
            }            
          }      
        }else{
          var it = this.form.fondomutuoinvertir[i];
          it.check = false;
          it.monto = null;

          var myIndex = this.form.fondos.indexOf(i);
          if (myIndex > -1) {
            this.form.fondos.splice(myIndex, 1);

          }
        }
      }
    },    
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.form5
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {

        this.$emit('setSaveForm', {id:"5", form: this.form, index: "7"});

      }

    },
    checkFondos(i, value){
      if(!value.check){
        this.form.fondomutuoinvertir[i].monto = null;
        var myIndex = this.form.fondos.indexOf(i);
        if (myIndex > -1) {
          this.form.fondos.splice(myIndex, 1);
        }
      }else{
        this.form.fondos.push(i)
      }
    },    
    getValidationClass (i,fieldName) {
      const field = this.$v.form.fondomutuoinvertir.$each[i][fieldName]
      //console.log("%s, %s",fieldName,field)
       if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }, 
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },    
    showItem(i){
      var val = false;
      if(this.in != "Si"){
        if(i == 0){
          val = true
        }else{
          val = false;
        }
      }else{
        val = true;
      }
      return val;
    },
    cssTypeFondo(){
     const a = this.form.fondomutuoinvertir.filter(value => value.ind == 0)
     const oba = a[0]
     var css = `
        .show${oba.id}${oba.ind} {
          display:block
        }
      `;
     if(this.in == 'Si'){
       const b = this.form.fondomutuoinvertir.filter(value => value.ind == 1)
       const obb = b[0]
       css += `
        .show${obb.id}${obb.ind} {
          display:block
        }
      `;
     }
      this.styleTag = document.createElement('style');
      this.styleTag.appendChild(document.createTextNode(css));
      document.head.appendChild(this.styleTag);
    }
  },
  destroyed() {
    this.styleTag.remove();
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }       
}
</script>
